import styled from 'styled-components';

export const Body = styled.div`
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;
  padding-bottom: 80px;
`;

export const Header = styled.div`
  position: sticky;
  top: 0;
  background-color: white;
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #E5E5E5;
  z-index: 10;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 20px;
  color: #333;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FormContainer = styled.div`
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

export const FormCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 0;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const TitleInput = styled.input`
  width: 100%;
  padding: 20px;
  border: none;
  border-bottom: 1px solid #E5E5E5;
  font-size: 16px;
  color: #333;
  outline: none;
  box-sizing: border-box;

  &::placeholder {
    color: #C5C5C5;
  }
`;

export const ContentTextarea = styled.textarea`
  flex: 1;
  width: 100%;
  padding: 20px;
  border: none;
  font-size: 15px;
  color: #333;
  outline: none;
  resize: none;
  font-family: inherit;
  box-sizing: border-box;

  &::placeholder {
    color: #C5C5C5;
  }
`;

export const SubmitButton = styled.button`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 48px);
  max-width: calc(480px - 48px);
  height: 52px;
  background-color: #1FBC70;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background-color: #18a860;
  }

  &:active:not(:disabled) {
    background-color: #159150;
  }

  &:disabled {
    background-color: #CCCCCC;
    cursor: not-allowed;
  }
`;
